// extracted by mini-css-extract-plugin
export var paginationContainer = "_7r-0";